import { memo, useState } from 'react';
import { WelcomeWidgetModel } from 'models';

import { WelcomeWidgetConfirmationDialog } from 'containers';
import { Button, Box } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  welcomWidgetData: WelcomeWidgetModel;
  initWelcomeWidget: () => void;
}

const WelcomeWidget = ({ welcomWidgetData, initWelcomeWidget }: Props) => {
  const classes = useStyles();
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  const handleOpenConfirmationDialog = () => {
    setConfirmationDialogOpen(true);
  };

  const handleCloseConfirmationDialog = (flag?: boolean) => {
    setConfirmationDialogOpen(false);

    if (flag) {
      initWelcomeWidget();
    }
  };

  return (
    <>
      <div className={classes.root}>
        <Button
          className={clsx(classes.closeBtn, classes.btn)}
          onClick={handleOpenConfirmationDialog}
        >
          <CloseIcon className={classes.closeIcon} />
        </Button>
        <Box
          display="flex"
          flex={1}
          flexDirection={{ xs: 'column', sm: 'row' }}
          mr={{ xs: 0, md: 2 }}
          mb={{ xs: 3, md: 0 }}
        >
          <Box
            marginRight={{ xs: 0, sm: '15px' }}
            marginBottom={{ xs: '20px', sm: 0 }}
          >
            {welcomWidgetData.Image ? (
              <img
                className={classes.logo}
                src={`data:image/png;base64,${welcomWidgetData.Image}`}
                alt="Logo"
              />
            ) : null}
          </Box>
          <Box display="flex" flexDirection="column">
            {welcomWidgetData.Subject ? (
              <h2 className={classes.subject}>{welcomWidgetData.Subject}</h2>
            ) : null}
            <p className={classes.text} style={{ whiteSpace: 'pre-wrap' }}>
              {welcomWidgetData.Text}
            </p>
            <p className={classes.user}>{welcomWidgetData.User}</p>
            <p className={classes.userRole}>{welcomWidgetData.UserRole}</p>
          </Box>
        </Box>
        <Box flex={1}>
          <h2 className={classes.pdfTitle}>Tutustu palveluun</h2>
          {welcomWidgetData.VideoUrl ? (
            <iframe
              className={classes.video}
              src={welcomWidgetData.VideoUrl}
              title="Tutustu palveluun"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : null}
        </Box>
      </div>
      {confirmationDialogOpen ? (
        <WelcomeWidgetConfirmationDialog
          handleClose={handleCloseConfirmationDialog}
        />
      ) : null}
    </>
  );
};

export default memo(WelcomeWidget);
